<template>
  <div>
    <b-loading :active="isLoading" :is-full-page="true"></b-loading>
    <div style="margin-top: 10px; padding: 0 10px; overflow-x: hidden">

      <transition name="fade" mode="out-in">

        <!-- choose plan -->
        <div v-if="step === steps.PLAN_SELECTION" :key="0">
          <a style="display: block" class="align-left" @click="$router.push('/')">
            <img alt="Go Back" src="../assets/arrow-left.png" style="width: 15px; margin: 5px"
                 :style="$store.state.language === 'ar' ? 'transform: rotate(180deg)' : ''">
            {{ $t('BackToMyPlan') }}
          </a>
                    <div v-if="!this.$store.state.settingFuture"
                         style="background: rgba(0, 0, 0, 0.2); border-radius: 5px; font-size: 0.9em; padding: 10px;">

                      {{ $t('PromoMsg2') }}
                    </div>
          <div style="display: flex; text-align: center">
            <a v-if="!$store.state.userInfo.tenureRestricted" @click="selectTab('customize')" class="tab-btn"
               :class="{'tab-btn-active': selectedTab === 'customize'}">
              <img style="width: 30px; margin-bottom: 10px" src="../assets/customize.png" alt="customize plan">
              <div>{{ $t('CustomizePlan') }}</div>
            </a>
            <a @click="selectTab('bundles')" class="tab-btn" :class="{'tab-btn-active': selectedTab === 'bundles'}">
              <img style="width: 30px; margin-bottom: 10px" src="../assets/bundles.png" alt="customize plan">
              <div>{{ $t('Bundles') }}</div>
            </a>
          </div>

          <plans-selector v-if="selectedTab === 'customize'" :plan="plan" @pickedplan="pickedPlan"/>
          <bundle-selector v-if="selectedTab === 'bundles'" @pickedplan="pickedPlan"/>

        </div>
        <div v-else-if="step === steps.PLAN_CONFIRMATION" class="align-left" :key="1">
          <!--                    Future: {{this.$store.state.settingFuture}}-->
          <a style="display: block" @click="step = steps.PLAN_SELECTION">
            <img alt="Go Back" src="../assets/arrow-left.png" style="width: 15px; margin: 5px"
                 :style="$store.state.language === 'ar' ? 'transform: rotate(180deg)' : ''">
            {{ $t('Back') }}
          </a>
          <div style="margin: 10px 0">
            <div class="has-text-weight-bold is-size-4">{{ $t('Confirmation') }}</div>
            <div style="margin: 10px 0 20px">{{ $t('ConfirmationMsg') }} <span
                class="has-text-weight-bold">{{ $store.state.userInfo.msisdn }}</span></div>

            <!--            <div v-if="!$store.state.userInfo.tenureRestricted && !this.$store.state.settingFuture"-->
            <!--                 style="background: rgba(0, 0, 0, 0.2); border-radius: 5px; font-size: 0.9em; padding: 10px;">-->
            <!--              <i class="fa fa-star" style="color: #ffd500"></i> {{ getCashbackAmountPromo() }}-->
            <!--            </div>-->

          </div>
          <div class="zain-card">
            <ul>
              <li class="plan-item" :key="index" v-for="(item, index) in planDetailsList">
                <div class="columns is-mobile">
                  <div class="column is-2 is-paddingless has-text-centered" style="width: 12.2%;">
                    <img v-if="item.type === 'DATA'" src="../assets/wifi.png" alt="plan benefit">
                    <img v-else-if="item.type.toLowerCase().includes('international')"
                         src="../assets/int-calls.png" alt="plan benefit">
                    <img v-else-if="item.type.toLowerCase().includes('minutes')"
                         src="../assets/calls.png" alt="plan benefit">
                    <img v-else-if="item.type.toLowerCase().includes('whatsapp')"
                         src="../assets/wa.png" alt="plan benefit">
                    <img v-else-if="item.type.toLowerCase().includes('social')"
                         src="../assets/fb.png" alt="plan benefit">
                    <img v-else-if="item.type.toLowerCase().includes('youtube')"
                         src="../assets/yt.png" alt="plan benefit">
                    <img v-if="item.type === '5G'" src="../assets/wifi.png" alt="plan benefit">
                  </div>
                  <div class="column has-text-black is-flex" style="flex-wrap: wrap;">
                    <div style="color: black" class="">{{ $tif(item.titleEn, item.titleAr) }}
                    </div>
                    <div style="flex-grow: 1"></div>
                    <span v-if="item.type === '5G'"></span>
                    <span v-else-if="item.isUnlimited">{{ $t('Unlimited') }} </span>
                    <template v-else>
                      <!--                      <span v-if="!item.type.toLowerCase().includes('international') && !$store.state.settingFuture" style="text-decoration: line-through; color: gray;padding: 0 7px;font-size: 1.2em;">{{ item.value.replace('.0', '') / 2 }}</span>-->
                      <div>
                        <span class="text-right">{{ item.value.replace('.0', '') }}</span>
                        <span style="font-size: 0.8em; vertical-align: center">{{
                            $tif(item.unitEn, item.unitAr)
                          }}</span>
                      </div>
                    </template>

                    <template v-if="item.type.toLowerCase().includes('social')">
                      <small class="has-text-black">
                        {{ $t('SocialNetworks') }}
                      </small>
                      <div style="padding-bottom: 5px" class="has-text-black"
                           v-if="$store.getters.getSettings().SOCIALMEDIA[1].price === '0'">
                        <i class="fa fa-star" style="color: #FFC107"></i>
                        <b class="has-text-black"> {{ $t('Free') }} </b>{{ $t('Free30Days') }}
                      </div>
                    </template>
                  </div>
                </div>
              </li>
              <li class="plan-item" v-if="this.price >= 8">
                  <div class="columns is-mobile">
                      <div class="column is-2 is-paddingless has-text-centered" style="width: 12.2%;">
                          <i style="color: rgb(255, 175, 0);font-size: 1.4em;line-height: 2;" class="fa fa-star"></i>
                      </div>
                      <div class="column has-text-black">
                          <div style="color: black">
                            <small style="color: black; font-size: 0.8em">{{ $t('OfferBenefitMessageAbove8KD') }}</small>
                          </div>
                          <br/>
                      </div>
                  </div>
              </li>
            </ul>
          </div>
          <br><br><br><br><br>
        </div>
        <div v-else-if="step === steps.RESULT" :key="2">
          <a style="display: block" class="align-left" @click="$router.push('/')">
            <img alt="Go Back" src="../assets/arrow-left.png" style="width: 15px; margin: 5px"
                 :style="$store.state.language === 'ar' ? 'transform: rotate(180deg)' : ''">
            {{ $t('BackToMyPlan') }}
          </a>
          <div style="margin: 10px 0; padding: 20px 10px 10px" class="zain-card">
            <br>
            <div>
              <i v-if="resultIsSuccess" class="fa fa-check-circle fa-5x" style="color: #4c9928"></i>
              <i v-else class="fa fa-times-circle fa-5x" style="color: #cd0000"></i>
            </div>
            <br>
            <div class="has-text-black" v-if="resultIsSuccess" style="padding: 20px">
              {{
                this.$store.state.settingFuture ? $t('PlanActivationSuccessFuture') :
                    $t('PlanActivationSuccess')
              }}
              <br><br>
              <div v-if="!$store.state.userInfo.tenureRestricted && !this.$store.state.settingFuture"
                   class="has-text-black align-left">
                {{ $t('PlanActivationSuccess1') }}
                <br>
                <br>
                <div class="has-text-black">
                  <ol>
                    <li>{{ $t('PlanActivationSuccess2') }}</li>
                    <li>{{ $t('PlanActivationSuccess3') }}</li>
                    <li>{{ $t('PlanActivationSuccess4') }}</li>
                  </ol>

                </div>
                <br>
                {{ $t('ThankYou') }}
              </div>
              <br>

            </div>
            <div class="has-text-black"
                 v-if="!resultIsSuccess && resultFailureReason === 'NoBalance'">
              <div style="padding: 10px">
                <p class="has-text-black">{{ $t('NoBalanceMessage1') }}</p>
                <br>
                <p class="has-text-black">{{ $t('NoBalanceMessage2') }}</p>
                <br>
              </div>
              <a :href="'https://www.kw.zain.com/en/web/quickpay?m=' + $store.state.userInfo.msisdn"
                 class="pink-btn"
                 style="margin: 20px 0 0; border: 1px solid; padding: 13px; display: block; border-radius: 5px;">
                {{ $t('RechargeNow') }}
              </a>
            </div>
            <div class="has-text-black" v-else-if="!resultIsSuccess && resultFailureReason === 'TenureLessThan30'"
                 style="padding: 20px">
              <p class="has-text-black">{{ $t('LowTenure1') }} {{ $store.state.userInfo.tenureCompletion.day }}
                {{ $t($store.state.userInfo.tenureCompletion.month) }}
                {{ $store.state.userInfo.tenureCompletion.year }}</p>
              <br>
              <p class="has-text-black">{{ $t('LowTenure2') }}</p>
              <br>
              <p class="has-text-black">{{ $t('LowTenure3') }}</p>
              <br>
              <br>
            </div>
            <div class="has-text-black" v-else-if="!resultIsSuccess" style="padding: 20px">
              {{ $t('FailureMessage') }}
              <br>
              <br>
            </div>
          </div>
        </div>
      </transition>

      <div v-if="(selectedTab === 'customize' || step === steps.PLAN_CONFIRMATION) && step !== steps.RESULT"
           class="product-bg zoomed">
        <div v-if="price < $store.getters.getMinimumPrice()" class="has-text-black align-left is-block disclaimer">
          {{ $t('PriceNotEnough1') + $store.getters.getMinimumPrice() + $t('PriceNotEnough2') }}
        </div>
        <div class="is-half align-left">
          <p dir="ltr">
            <span style="color: black; font-weight: bold">
              KD <span style="text-decoration: line-through; color: black; font-weight: bold; font-size: 1.2em; padding: 0 5px"
                       v-if="discountApplied">{{ price }}</span> <em>{{ finalPrice }}</em>
            </span>
            <br/>
          </p>
          <p v-if="price >= $store.getters.getMinimumPrice()" class="product-bg-sub-text">{{ $t('PlanDuration') }}</p>
        </div>
        <div class="is-half align-right" style="padding-top: 10px">
          <a @click="price < $store.getters.getMinimumPrice() ? () => {} : nextStep()" class="btn right"
             :style="price < $store.getters.getMinimumPrice()? 'opacity: 0.5' :''">
            {{ step === steps.PLAN_CONFIRMATION ? $t('Confirm') : $t('Next') }}
          </a>
        </div>

        <div class="tbl span">
          <div class="row span">
            <div class="col span pull-down">
              <div class="dbug">
                {{ getFooterMessage }}
              </div>

            </div>
          </div>
        </div>

<!--        <div class="has-text-black is-size-6 has-background-white" style="position: absolute; width: 100%; top: -20px; vertical-align: bottom">-->
<!--          {{ getFooterMessage }}-->
<!--        </div>-->
        <div v-if="price >= $store.getters.getMinimumPrice()" class="has-text-black align-left is-block disclaimer">
          {{ $t('ByClicking') }} <a
            style="color: black; text-decoration: underline">{{ $t('Terms') }}</a></div>

      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import BLoading from "buefy/src/components/loading/Loading"
import PlansSelector from "../components/PlansSelector"
import BundleSelector from "../components/BundleSelector"

const Modal = {
  template: `<div class="modal-card" style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">{{this.$t('PlanActivation')}}</p>
                        <a class="float-right" @click="$parent.close()"><i class="fa fa-times has-text-black" /></a>
                    </header>
                    <section class="modal-card-body">
                        <div class="has-text-centered">
                            <b>{{this.$t('ActivateNowLater')}}</b>
                            <br>
                            <br>
                            <small class="has-text-black">{{this.$t('PlanExpireIn')}}
                                <span style="color: #ff368d; font-weight: bold; font-size: 1.1em">
                                {{this.$store.state.userInfo.currentOfferEndsAfterDays}} {{$t('days')}}
                                </span>
                            </small>
                        </div>
                    </section>
                    <footer class="modal-card-foot" style="flex-wrap: wrap">
                        <button class="button is-fullwidth" style="margin: 0" @click="$emit('setPlan', true) && $parent.close()">{{this.$t('PlanForLater')}}</button>
                        <button class="button is-primary is-fullwidth" style="margin-top: 10px !important" @click="$emit('setPlan', false) && $parent.close()">{{this.$t('ActivateNow')}}</button>
                    </footer>
                </div>`
}
// noinspection ES6ShorthandObjectProperty
export default {
  name: "BuyLine",
  components: {
    BundleSelector,
    PlansSelector,
    BLoading
  },
  data: () => {
    return {
      plan: {},
      pickedPlanCode: null,
      step: 1,
      planType: 'Custom',
      paddingTop: 0,
      isLoading: false,
      price: 0.000,
      selectedTab: 'customize',
      result: '',
      resultIsSuccess: false,
      resultFailureReason: '',
      settingFutureOffer: false,
      steps: {
        INTRO: 0,
        PLAN_SELECTION: 1,
        PLAN_CONFIRMATION: 2,
        RESULT: 3
      },
      discountEnabled: false,
      discountApplied: false,
      discountAppliedForUpsell: false,
      discountPct: 0.20,
      minimumDiscountOrder: 8
    }
  },
  computed: {
    planDetailsList() {
      return Object.values(this.plan)
          .filter(x => x && x.value && (parseFloat(x.value) > 0 || x.isSelected || x.value === 'UL'))
    },
    finalPrice() {
      const price = Number(this.price)
      if (!this.discountApplied) {
        return price
      } else {
        return price - (price * this.discountPct)
      }
    },
    getFooterMessage() {
      if (this.price >= 8) return this.$t('FooterMessageAbove8KD')
      const remaining = 8 - this.price
      return this.$t('FooterMessageBelow8KD').replace('XX', remaining.toPrecision(2))
    }
  },
  methods: {
    selectTab(selectedTab) {
      this.selectedTab = selectedTab
    },
    pickedPlan(planInfo) {
      if (this.discountEnabled) {
        const total = parseFloat(planInfo.total)
        this.discountAppliedForUpsell = total + 1 >= this.minimumDiscountOrder
        this.discountApplied = total >= this.minimumDiscountOrder
      }

      this.price = planInfo.total
      this.plan = planInfo.plan
      this.planType = planInfo.planType
      this.pickedPlanCode = planInfo.code

      if (planInfo.goToNextStep) this.nextStep()
    },
    async nextStep() {
      if (this.step === this.steps.PLAN_SELECTION) {
        this.step = this.steps.PLAN_CONFIRMATION
        return
      }

      if (this.step === this.steps.PLAN_CONFIRMATION) {
        // let sameOffer = false
        // let vm = this.$store
        // if (this.$store.state.userInfo.hasFlexiOffer) {
        //   let comparison = Object.values(this.plan).map(x => {
        //     let curVal = vm.state.userInfo[this.$store.state.settingFuture ? 'futureOrderBenefits' : 'currentOfferBenefits'].filter(y => y.type === x.type)[0]
        //     return x.value.replace('.0', '') === curVal.value
        //   })
        //
        //   sameOffer = comparison.every(x => x)
        // }
        //
        // if (sameOffer) {
        //   this.$buefy.dialog.alert({
        //     message: this.$t('SameOffer'),
        //     confirmText: this.$t('OK')
        //   })
        //   return
        // }

        if (this.$store.state.userInfo.hasFlexiOffer && !this.$store.state.settingFuture) {
          this.$buefy.modal.open({
            parent: this,
            component: Modal,
            hasModalCard: true,
            trapFocus: true,
            events: {
              'setPlan': (later) => {
                if (later)
                  this.$store.state.settingFuture = true
                this.setPlan()
              }
            }
          })
          return
        }

        await this.setPlan()

        //this.$ga.event('SetPlan', 'Set-' + this.$store.state.settingFuture ? 'Future' : 'Current')

      }
    },
    async setPlan() {

      if (this.$store.state.userInfo.currentOfferCode && !this.$store.state.settingFuture) {
        this.$buefy.dialog.confirm({
          cancelText: this.$t('Cancel'),
          confirmText: this.$t('Yes'),
          message: this.$t('SwapConfirmation'),
          onConfirm: () => {
            this.checkUpsellOffer()
          }
        })

        return
      }

      await this.checkUpsellOffer()
    },
    async checkUpsellOffer() {
      if (!this.$store.state.settingFuture && !this.$store.state.userInfo.tenureRestricted) {
        try {
          const upsell = (await this.$store.dispatch('getUpsellSettings', {
            plan: this.plan,
            hasPRAL8: this.$store.state.userInfo.hasPRAL8
          })).data

          // console.log(upsell)

          if (upsell.eligible && upsell.upsell) {
            const validUpsellOptions = Object.entries(upsell.upsell).filter(x => x[1])
            if (validUpsellOptions.length > 0) {
              const randomElement = validUpsellOptions[Math.floor(Math.random() * validUpsellOptions.length)]
              // console.log(validUpsellOptions)
              // console.log('randomElement', randomElement)
              const upsellOffer = randomElement[0]
              const message = this.$store.state.upsellOffersMessages[upsellOffer][this.$store.state.language]
              const offerName = this.$store.state.upsellOffers[upsellOffer][this.$store.state.language]
              // console.log(message)

              this.$buefy.modal.open({
                hasModalCard: true,
                trapFocus: true,
                parent: this,
                events: {
                  upsell: (upsellOffer) => this.confirmSetPlan(upsellOffer)
                },
                props: {
                  price: this.price,
                  finalPrice: this.finalPrice,
                  discountApplied: this.discountApplied,
                  discountAppliedForUpsell: this.discountAppliedForUpsell,
                  message,
                  offerName,
                  upsellOffer
                },
                component: {
                  props: { price: [String, Number], finalPrice: Number, message: String, offerName: String, upsellOffer: String, discountApplied: Boolean, discountAppliedForUpsell: Boolean },
                  template: `
                    <div class="modal-card" style="max-width: 420px; margin: 0 auto">
                    <header class="modal-card-head">
                      <p class="modal-card-title"></p>
                      <a class="float-right" @click="$parent.close()"><i class="fa fa-times has-text-black"/></a>
                    </header>
                    <section class="modal-card-body">
                      <div class="has-text-centered">
                        <b> {{ message }} </b>
                        <br>
                        <br>

                        <div style="display: flex; justify-content: space-between">
                          <p>{{ $t('MainPlanPrice') }}</p>
                          <p>KD <span v-if="discountApplied" style="text-decoration: line-through; color: black; font-weight: bold; font-size: 1.2em; padding: 0 5px">{{ price }}</span>
                            <b>{{ finalPrice }}</b>
                          </p>
                        </div>


                        <div style="display: flex; justify-content: space-between">
                          <p>{{ offerName }}</p>
                          <p>KD <b>1.000</b>
                          </p>
                        </div>
                        <div style="display: flex; justify-content: space-between">
                          <p>{{ $t('Total') }}</p>
                          <p>
                            KD <span v-if="discountAppliedForUpsell" style="text-decoration: line-through; color: black; font-weight: bold; font-size: 1.2em; padding: 0 5px">{{ (Number(price) + 1).toFixed(3) }}</span>
                            <b v-if="discountAppliedForUpsell">{{  (Number(price) + 1) - ((Number(price) + 1) * 0.20) }}</b>
                            <b v-else>{{ (Number(finalPrice) + 1).toFixed(3) }}</b>
                          </p>
                        </div>

                      </div>
                    </section>
                    <footer class="modal-card-foot" style="flex-wrap: wrap">
                      <button class="button is-fullwidth" style="margin: 0"
                              @click="$emit('upsell', false) && $parent.close()">{{ this.$t('NoThanks') }}
                      </button>
                      <button class="button is-primary is-fullwidth" style="margin-top: 10px !important"
                              @click="$emit('upsell', upsellOffer) && $parent.close()">{{ this.$t('YesPlease') }}
                      </button>
                    </footer>
                    </div>`
                }
              })
            } else {
              await this.confirmSetPlan()
            }

          } else {
            await this.confirmSetPlan()
          }

        } catch (e) {
          await this.confirmSetPlan()
          console.error(e)
        }
      } else {
        await this.confirmSetPlan()
      }

    },
    async confirmSetPlan(upsellOffer = false) {

      this.isLoading = true

      if (!this.$store.state.userInfo.tenureRestricted) {
        this.result = (await this.$store.dispatch('subscribe', {
          plan: this.plan,
          upsellOffer,
          isFutureOrder: this.$store.state.settingFuture,
          hasPRAL8: this.$store.state.userInfo.hasPRAL8
        })).data
      } else {
        this.result = (await this.$store.dispatch('subscribeWithCode', this.pickedPlanCode)).data
      }

      if (this.result.error) {
        this.resultFailureReason = this.result.error
      } else if (this.result.isSuccess) {
        this.resultIsSuccess = true
        this.$store.state.isDirty = true
      }

      this.isLoading = false
      this.step = this.steps.RESULT

      this.$ga.event('SetPlan', `Result-${ (this.$store.state.settingFuture ? 'Future' : 'Current') }-${ (this.result.isSuccess ? 'Success' : 'Failure') }`, this.result.error)

      if (this.result.isSuccess && !this.$store.state.settingFuture && !this.$store.state.userInfo.tenureRestricted) {
        this.$ga.event('BuyPlan', this.planType, Object.values(this.plan).map(x => `${ x.type }-${ x.value }`).join('|'), parseFloat(this.price))
      } else if (this.result.isSuccess) {
        this.$ga.event('BuyPlan', this.planType, this.pickedPlanCode, parseFloat(this.price))

      }
    },
    setDefaultPlanValues() {
      this.plan.valueGBs = this.$store.getters.getSettings().DATA[2]
      this.plan.valueMinutesOnNet = this.$store.getters.getSettings().ONNETMINUTES[2]
      this.plan.valueMinutesOffNet = this.$store.getters.getSettings().LOCALMINUTES[1]
      this.plan.valueInternationalMinutes = this.$store.getters.getSettings().INTERNATIONALMINUTES[1]
      this.plan.valueSocialMedia = this.$store.getters.getSettings().SOCIALMEDIA[0]
      this.plan.valueWhatsApp = this.$store.getters.getSettings().WHATSAPP[0]
      this.plan.valueYouTube = this.$store.getters.getSettings().YOUTUBE[0]
      this.plan.value5G = this.$store.getters.getSettings()['5G'][0]
    },
    getCashbackAmountPromo() {
      let lang = this.$store.state.language
      let extra
      if (this.price >= 5.000 && this.price <= 7.999) {
        extra = 1
      } else if (this.price >= 8 && this.price <= 11.999) {
        extra = 2
      } else if (this.price >= 12 && this.price <= 17.999) {
        extra = 3
      } else if (this.price >= 18) {
        extra = 5
      }


      let str = {
        en: `You will receive ${ extra }KD Bonus Credit!`,
        ar: `ستحصل على رصيد اضافي بقيمة ${ extra } د.ك!`
      }

      return str[lang]
    },
    finalPriceWithUpsell() {
      if (!this.discountApplied) {
        return this.price
      } else {
        return this.price - (this.price * this.discountPct)
      }
    }
  },
  beforeMount() {
    if (this.$store.state.userInfo.tenureRestricted) this.selectedTab = 'bundles'

    if (this.$store.state.userInfo.hasFlexiOffer) {

      let userValueGBs = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === 'DATA').value
      let userValueMinutesOnNet = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === 'ON-NET MINUTES').value
      let userValueMinutesOffNet = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === 'LOCAL MINUTES').value
      let userValueInternationalMinutes = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === 'INTERNATIONAL MINUTES').value
      let userValueSocialMedia = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === 'SOCIAL MEDIA').value
      let userValueWhatsApp = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === 'WHATSAPP').value
      let userValueYouTube = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === 'YOUTUBE').value
      let userValue5G = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === '5G')

      if (userValue5G)
        userValue5G = userValue5G.value
      else
        userValue5G = 0

      this.plan.valueGBs = this.$store.getters.getSettings().DATA.find(x => x.value.replace('.0', '') === userValueGBs)
      this.plan.valueMinutesOnNet = this.$store.getters.getSettings().ONNETMINUTES.find(x => x.value.replace('.0', '') === userValueMinutesOnNet)
      this.plan.valueMinutesOffNet = this.$store.getters.getSettings().LOCALMINUTES.find(x => x.value.replace('.0', '') === userValueMinutesOffNet)
      this.plan.valueInternationalMinutes = this.$store.getters.getSettings().INTERNATIONALMINUTES.find(x => x.value.replace('.0', '') === userValueInternationalMinutes)
      this.plan.valueSocialMedia = this.$store.getters.getSettings().SOCIALMEDIA.find(x => x.value.replace('.0', '') === userValueSocialMedia)
      this.plan.valueWhatsApp = this.$store.getters.getSettings().WHATSAPP.find(x => x.value.replace('.0', '') === userValueWhatsApp)
      this.plan.valueYouTube = this.$store.getters.getSettings().YOUTUBE.find(x => x.value.replace('.0', '') === userValueYouTube)
      this.plan.value5G = this.$store.getters.getSettings()['5G'].find(x => x.value.replace('.0', '') === userValue5G)

      if (Object.values(this.plan).some(x => !x))
        this.setDefaultPlanValues()

    } else {
      this.setDefaultPlanValues()
    }
  }
}

</script>

<style lang="scss" scoped>

.back-btn {
  float: left;
  top: 19px;
  /*left: 0;*/
  position: relative;
}

[dir='rtl'] .back-btn {
  float: right;
}

* {
  color: white;
}

h4 {
  margin-top: 20px;
}

button {
  background-color: unset;
  border: 1px white solid;
  padding: 20px;
  color: white;
  font-weight: 600;
  width: 100px;
  margin: 0 20px 20px;
}

.selected-option {
  background: rgba(238, 238, 238, 0.27);
}

.is-half {
  display: inline-block;
  width: 50%;
  margin: 0;
  padding: 0;
  vertical-align: top;
}

.product-bg {
  height: 100px;
  background-color: #ffd500;
  color: black;
}


.product-bg em {
  display: inline-block;
  font-size: 1.7em;
  font-style: normal;
  font-weight: bold;
  margin-top: 0;
  color: black;
}

.product-bg a.btn {
  position: relative;
  right: 10px;
  color: white;
  background-color: #d12984;
  display: inline-block;
  font-size: 11pt;
  padding: 12px 0;
  text-transform: uppercase;
  width: 130px;
  text-align: center;
  border-radius: 5px;
  text-decoration: none;
  line-height: 1;
}

[dir='rtl'] .product-bg a.btn {
  right: unset;
  left: 10px;
  padding: 8px 0 13px;

}

.product-bg p {
  font-size: 0.85em;
  margin: 0;
  display: inline-block;
  line-height: 1;
  color: black;
  padding: 5px 0 0 10px;
  vertical-align: middle;
}

[dir='rtl'] .product-bg p {
  padding: 10px 10px 0 0;
}

.product-bg-sub-text {
  padding: 5px 0 0 10px !important;;
  display: block !important;
}

[dir='rtl'] .product-bg-sub-text {
  padding: 5px 10px 0 0 !important;
}

.zoomed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 30;
}

.disclaimer {
  color: black;
  opacity: 0.7;
  padding: 5px 10px 0;
  font-size: 0.80em;
  line-height: 1.2;
}

[dir='rtl'] .disclaimer {
  text-align: right;
  font-size: 0.8em;

}

.btn-inactive {
  opacity: 0.3;
}

.zain-card {
  padding: 20px;
  border-radius: 5px;
  background: white;
  color: black;
}

.plan-item {
  /*padding: 15px;*/
}

.plan-item, .plan-item span {
  color: black;
  font-size: 1.0em;
  /*text-align: left;*/

}

.plan-item span {
  font-weight: bold;
  font-size: 1.2em;
}

.plan-item:last-child {
  margin-bottom: 0;
}

.plan-item img {
  padding-top: 7px;
  max-width: 35px;
  text-align: center;
}

ol li {
  color: black;
  margin-bottom: 0;
}



.tbl
{
  display: table;
  position: absolute;
  width: 100%;
  bottom: 100px;
}

.row
{ display: table-row; }

.col
{ display: table-cell; }

.pull-down
{ vertical-align: bottom; }



.dbug
{
  padding: 4px;
  box-sizing:border-box;
  -moz-box-sizing:border-box;
  -webkit-box-sizing:border-box;
  background: #D12B8A;
}

</style>
